import { WIDGET_TYPE } from "constants/constantStrings";
import GRID_CONSTANTS from "components/GridLayout/GridConstants";

export const getDefaultLayout = dashboardMainWidgets => {
  return dashboardMainWidgets.map(widget => {
    const { x, y } = calculateCoordinates(widget.Order);

    return {
      i: widget.Id.toString(),
      id: widget.Id,
      x,
      y,
      w: widget.width,
      h: GRID_CONSTANTS.DEFAULT_GRID_HEIGHT
    };
  });
};

export const getGridWidth = type => (type === WIDGET_TYPE.timeseries ? GRID_CONSTANTS.GRID_WIDTH_TIMESERIES : GRID_CONSTANTS.GRID_WIDTH_TAG);

export const calculateLinearIndex = (rowIndex, colIndex) => rowIndex * GRID_CONSTANTS.MAX_GRID_COLS_DASHBOARD + colIndex;

export const calculateCoordinates = linearIndex => {
  const x = linearIndex % GRID_CONSTANTS.MAX_GRID_COLS_DASHBOARD;
  const y = Math.floor(linearIndex / GRID_CONSTANTS.MAX_GRID_COLS_DASHBOARD);
  return { x, y };
};

/**This function is for backward compatibity if any of the order is null
 *  or any order which voilates the order according new grid implementation will returning false*/
export const validateOrder = dashboardMainWidgets => {
  let lastX = null;
  let lastY = null;

  for (const item of dashboardMainWidgets) {
    if (item.Order === null) {
      return false;
    }

    const { x, y } = calculateCoordinates(item.Order);
    const width = getGridWidth(item.Type);

    if (lastX !== null && lastX + width !== x && y === lastY) {
      return false;
    }

    lastX = x;
    lastY = y;
  }

  return true;
};

export const getLayouts = widgets => {
  const layouts = [];
  let x = 0;
  let y = 0;

  for (let index = 0; index < widgets.length; index++) {
    const widget = widgets[index];

    if (index > 0) {
      const { width: lastWidgetWidth } = widgets[index - 1];

      if (x >= GRID_CONSTANTS.MAX_GRID_COLS_DASHBOARD - 1 || x + lastWidgetWidth + widget.width > GRID_CONSTANTS.MAX_GRID_COLS_DASHBOARD) {
        x = 0;
        y++;
      } else {
        x += lastWidgetWidth;
      }
    }

    layouts.push({
      i: widget.Id.toString(),
      x,
      y,
      w: widget.width,
      h: GRID_CONSTANTS.DEFAULT_GRID_HEIGHT,
      order: calculateLinearIndex(y, x)
    });
  }

  return layouts;
};
